<template>
  <v-app>
      <v-container class=" mt-8">
    <div>



        <div class="col-md-12">
          <div class="card">

            <v-container fluid>
              <v-card elevation="2" outlined>
                <v-card-title>
                  <!--                                    v-if="$can('transaction_create')"-->
                  <!--                  <v-btn to="/reports/create" rounded color="#308BB0" class="text-white">-->
                  <!--                    <v-icon>mdi-plus</v-icon>-->
                  <!--                    افزودن-->
                  <!--                  </v-btn>-->
                  <v-spacer/>
                  {{ $route.meta.title }}
                  <v-spacer/>
                  <v-btn :loading="loading" @click="reloadTable" rounded
                         class="btn-management">
                    <v-icon>mdi-refresh</v-icon>
                    به روزرسانی
                  </v-btn>

                </v-card-title>
                <v-divider/>

                <div class="row">

                  <div class="col-md-12 p-5">


                    <data-table
                        :data="data"
                        :columns="columns"
                        :debounce-delay="5000"
                        :translate="translate"
                        :per-page="[10, 25, 50, 100, 400]"
                        @on-table-props-changed="reloadTable"
                    >
                    </data-table>

                  </div>
                </div>

              </v-card>

            </v-container>


          </div>
        </div>


    </div>
      </v-container>
  </v-app>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import SinglePaginate from "@/view/content/SinglePaginate";
import {getTextSmsInfo, Language} from "@/Utilities/Utilities";
import actionButton from "@/view/content/button";


export default {
  components: {
    SinglePaginate,
  },
  data() {
    return {
      card : {
        color : null,
        text : "",
        textInfo : {
          total : 0,
          farsi : 0,
          smsCount : 0,
          lang : Language.English,

        },
        data: null
      },
      dialog :{
        show : true,
        loading: true,
      },
      loading: false,
      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      url: 'userInfo/list',
      data: {},
      columns: [
        {
          label: 'شناسه کاربر',
          name: 'user_id',
          width: '50px',
          orderable: true,
        },
        {
          label: 'نام کاربر',
          name: 'user_id',
          width: '50px',
          transform(data){
            return data.data.user.name;
          },
        },
        {
          label: 'نام مجموعه',
          name: 'collection_name',
          orderable: true,
          serchable: true,
        },
        {
          label: 'ادرس مجموعه',
          name: 'collection_address',
          orderable: true,

        },
        {
          label: 'شیوه پرداخت',
          name: 'payment_terms',
          orderable: true,
        },
        {
          label: 'تاریخ درخواست ',
          name: 'updated_at',
          transform(date){
            console.log(date);
            return this.getDateTimeTime(date.data.updated_at) + " " + this.jalalian(date.data.updated_at);
          },
          orderable: true,
        },


        {
          label: 'وضعیت',
          name: 'status',
          transform: (value) => {
            switch (value.data.status){
              case "accept":
                return "فعال"
              case "pending":
                return "در انتظار تایید"
              case "reject":
                return "رد شده"
            }
          },
          orderable: true
        },

        {
          label: 'عملیات',
          name: 'actions',
          component: actionButton,
          handler: this.actions,
          event: 'action',
          meta: {
            permission_prefix: 'user_',
            buttons: [
              {
                name : "edit",
                label : "مشاهده اطلاعات کاربری",
                icon : "pencil-alt",
                type:'edit',
                action: (a , b)=>{
                  console.log(a , b)
                  this.goto(`user-infos/${a.user_id}`)
                },
                permission : "show_additional_user_info"
              },
            ]
          }
        },


      ],


    }
  },
  methods: {
    reloadTable(tableProps) {
      this.getPacks(this.url, tableProps);
    },

    getPacks(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
          .then(response => {
            this.loading = false
            this.data = response.data;
          })
          .catch(error => {
            console.log(error);
          });
    },

    action(data, type) {
      this[type](data);
    },

    async delete(data) {

      if(await this.$modal.yesNo('آیا از حذف تعرفه اطمینان دارید؟' , 'حذف بسته')){
        this.requestApiDelete(`${this.url}/${data.id}`)
            .then(response => {
              this.reloadTable(this.url);
              this.$toast.success('گزارش با موفقیت حذف شد');
            })
            .catch(error => {
              console.log(error);
            });
      }

    },

    edit(data) {
      this.$router.push({
        name: 'reports.edit',
        params: {
          data: data
        }
      })
    },

    fetch(n){
      return;
      this.$modal.showLoading()
      this.loading = true
      this.requestApiGet('userInfo/list', {page:n, per_page:1, length:1})
          .then(({data})=>{
            this.card.data = data
            let text = data.data[0] ?  data.data[0].message : ""
            let info = getTextSmsInfo(text)
            this.card.textInfo.total = text.length
            this.card.textInfo.farsi = info.persianChar
            this.card.textInfo.smsCount = info.smsCount
            this.card.textInfo.lang = info.lang
          })
          .catch((r)=>{
            console.log(r);
            // this.card.data = {
            //   current_page : 0,
            //   last_page : 0,
            //   data:[]
            // }
            this.$toast.error("خطا در دریافت اطلاعات")
          })
          .finally(()=>{
            this.$modal.hideLoading();
            this.loading = false;
          })

      console.log(n)
    },
    async accept(id) {
      if (await this.$modal.yesNo(this.$t("DIALOGS.AcceptItQuestion"))){
        this.loading = true;
        this.requestApiPost(`admin/message/active/${id}`, {
          // id: this.data.id,
          state: 'accepte',
        })
            .then(({data}) => {
              this.$toast.success(this.$t('DIALOGS.Accepted'))
              this.fetchAfterAction()
            }).

        catch(()=>{
          this.$toast.error(this.$t('DIALOGS.Error'))
          this.loading =false;
        })
      }
    },
    async reject(id) {

      if (await this.$modal.yesNo(this.$t("DIALOGS.RejectItQuestion"))){
        this.loading = true;
        this.requestApiPost(`admin/message/active/${id}`, {
          // id: this.data.id,
          state: 'reject',
        })
            .then(({data}) => {
              this.$toast.success(this.$t('DIALOGS.Rejected'))
              this.fetchAfterAction()
            })
            .catch(()=>{
              this.$toast.error(this.$t('DIALOGS.Error'))
              this.loading = false
            })
      }



    },

    fetchAfterAction(){
      if (this.card.data.current_page === this.card.data.last_page){
        this.fetch(this.card.data.current_page - 1)
      }else{
        this.fetch(this.card.data.current_page)
      }
    }

  },

  created() {
    this.fetch(1);
    this.getPacks(this.url);
    this.setBreadcrumb(this.$route.meta.title);
  },
  watch:{
    loading(){
      if (this.loading && this.tableProps.search){
        this.$modal.showLoading()
      }else{
        this.$modal.hideLoading()
      }
    }
  }

}
</script>
